import React from 'react';
import { ReactSVG } from 'react-svg';
import styled from 'styled-components';

export const SacriLogo = ({
  logoType = 'main',
  w = 170,
}: {
  logoType?: 'main' | 'red';
  w?: number;
}) => {
  const src = logoType === 'main' ? '/images/logo/main.svg' : '/images/logo/red.svg';
  return (
    <H w={w}>
      <ReactSVG src={src} />
    </H>
  );
};

const H = styled.h1<{ w: number }>`
  width: ${({ w }) => {
    const per = (w / 375) * 100;
    return `${per}%`;
  }};
  max-width: 400px;
  margin: 0 auto;
  svg {
    width: 100%;
  }
`;

export default SacriLogo;
